import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; // Usa Routes invece di Switch
import Header from './components/header';
import Section1 from './components/section1';
import Benefits from './components/benefits';
import Contactus from './components/contactus';
import Footer from './components/footer';
import Context from './components/context';
import Privacy from "./components/privacy";
import Terms from "./components/terms";
import Faq from "./components/faq";

export default function App() {
    const [bandierine, setBandierine] = useState(false);
    const [traduzione, setTraduzione] = useState(LanguageFirstSetup());
    const [linguaAttuale, setLinguaAttuale] = useState(navigator.language || navigator.userLanguage);

    const contextValue = {
        traduzione,
        setTraduzione,
        SwitchLanguage,
        linguaAttuale,
        setLinguaAttuale
    };

    function LanguageFirstSetup() {
        // Ottieni il valore completo dalla lingua del browser
        const browserLang = navigator.language || navigator.userLanguage || "it";
        
        // Estrai il codice lingua principale (prima parte prima del trattino)
        const primaryLang = browserLang.split('-')[0].toLowerCase();
        
        // Log per debug
        console.log("Lingua del browser rilevata:", browserLang);
        console.log("Lingua primaria estratta:", primaryLang);
        
        // Lingue supportate dall'app
        const supportedLanguages = ["es", "it", "en"];
        
        // Usa la lingua primaria se supportata, altrimenti fallback su "es"
        const langToUse = supportedLanguages.includes(primaryLang) ? primaryLang : "es";
        
        let translations;
        try {
            translations = require(`./components/lang/${langToUse}`);
        } catch (error) {
            console.error(`Errore nel caricamento delle traduzioni per ${langToUse}:`, error);
            // Fallback sicuro
            translations = require('./components/lang/it');
        }
        
        return translations;
    }

    function SwitchLanguage(country) {
        // Normalizza l'input per sicurezza
        const langCode = country.toLowerCase();
        setLinguaAttuale(langCode);
        
        let translations;
        try {
            translations = require(`./components/lang/${langCode}`);
        } catch (error) {
            console.error(`Errore nel caricamento delle traduzioni per ${langCode}:`, error);
            // Fallback su spagnolo
            translations = require('./components/lang/it');
        }
        
        setTraduzione(translations);
    }

    return (
        <BrowserRouter>
            <Context.Provider value={contextValue}>
                <Routes>
                    <Route path="/privacy" element={
                        <>
                            <Header />
                            <Privacy />
                            <Footer />
                        </>
                    } />
                    <Route path="/terms" element={
                        <>
                            <Header />
                            <Terms />
                            <Footer />
                        </>
                    } />
                    <Route path="/faq" element={
                        <>
                            <Header />
                            <Faq />
                            <Footer />
                        </>
                    } />
                    <Route path="/" element={
                        <>
                            <Header />
                            <main className="main-content">
                                <Section1 />
                                <Benefits />
                                <Contactus />
                                <Footer />
                            </main>
                        </>
                    } />
                </Routes>
            </Context.Provider>
        </BrowserRouter>
    );
}